import { Component, Input, OnInit } from '@angular/core';
import { ProformViewStates } from '../../../dtos/proforms.dto';
import { ProformsSubmissionService } from '../../../services/proforms/proforms-submission.service';
import { CreateProformSubmissionPayload } from '../../../types/payloads/proforms.payloads';
import {
  ProFormsQuestionAPIResponse,
  ProFormsSubmissionAPIResponse,
} from '../../../types/responses/proforms.responses';
import { FieldTypeSpecs } from '../proforms-admin/proforms-admin-question-answer-scale/proforms-admin-question-answer-scale.component';

@Component({
  selector: 'app-proforms-question-answer-scale',
  standalone: false,
  templateUrl: './proforms-question-answer-scale.component.html',
  styleUrls: ['./proforms-question-answer-scale.component.scss'],
})
export class ProformsQuestionAnswerScaleComponent implements OnInit {
  @Input() question: ProFormsQuestionAPIResponse;

  @Input() viewState: ProformViewStates;

  @Input() fieldTypeSpecs: FieldTypeSpecs;

  viewStates = ProformViewStates;

  selectedAnswerOptionId: number | null = null;

  constructor(private proformsSubmissionService: ProformsSubmissionService) {}

  ngOnInit(): void {
    if (this.question) {
      this.fieldTypeSpecs = JSON.parse(this.question.field_type_specs);
      if (
        this.viewState === this.viewStates.SUBMITTED ||
        this.viewState === this.viewStates.GRADED
      ) {
        this.proformsSubmissionService.currentSubmission.subscribe(
          (submission) => {
            this.setAnswerFromSubmission(submission);
          }
        );
      } else if (this.viewState === this.viewStates.EDIT) {
        this.proformsSubmissionService.newSubmission.subscribe((submission) => {
          this.setAnswerFromSubmission(submission);
        });
      }
    }
  }

  get isInputInteractive(): boolean {
    return this.viewState === this.viewStates.EDIT;
  }

  setAnswerFromSubmission(
    submission:
      | CreateProformSubmissionPayload
      | ProFormsSubmissionAPIResponse
      | null
  ): void {
    if (!submission?.answers) return;

    const answer = submission.answers.find(
      (a) => a.proform_form_question_id === this.question.id
    );

    this.selectedAnswerOptionId =
      answer?.proform_form_question_answer_option_id ?? null;
  }

  onOptionChange(optionId: number, event: Event): void {
    if (this.viewState !== this.viewStates.EDIT) return;

    const input = event.target as HTMLInputElement;

    if (input.checked) {
      this.selectedAnswerOptionId = optionId;

      this.proformsSubmissionService.addAnswerToPayload(
        {
          proform_form_question_id: this.question.id,
          proform_form_question_answer_option_id: optionId,
        },
        this.question.field_type
      );
    }
  }
}
